angular.module('moebiusProadapt').controller('ctrlHome',
    ['$scope', '$location', function($scope, $location){

    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/home.js